<kendo-card
  [class.revert-color]="primary"
  [class.with-preview]="withPreview"
  [class.without-preview]="!withPreview"
  class="singleNews"
>
  <kendo-card-body (click)="open(false)">
    <ng-container *ngIf="dataItem.get('hasPreview'); else noPreview">
      <img *ngIf="withPreview" [src]="preview" kendoCardMedia />
    </ng-container>
    <ng-template #noPreview>
      <img *ngIf="withPreview" kendoCardMedia class="placeholder" />
    </ng-template>
    <div class="news-header">
      <a class="headline-link" (click)="open(false)"> {{ dataItem.getLocalizedContent().get('headline') }}</a>
    </div>
  </kendo-card-body>
  <kendo-card-footer *ngIf="!primary || editable" class="k-hbox news-card-footer">
    <ng-container *ngIf="editable">
      <div class="btn-container">
        <button mat-button color="primary" (click)="open(true)">Редактировать</button>
        <button mat-button color="warn" (click)="remove()">Удалить</button>
      </div>
    </ng-container>
    <!-- почему-то тип выдаёт unknown, а потому падает ошибка из Pipe о недопустимом параметре -->
    <div class="to-right">{{ $any(dataItem.get('postDate')) | date: 'shortDate' }}</div>
  </kendo-card-footer>
</kendo-card>
